import React, { useContext } from 'react';

import { DataContext } from '../../stores/crm-organization-store';
import { DataContext as SharedDataContext } from '../../stores/crm-store';

import GenericFormModal from './shared/GenericFormModal';
import EditText from './shared/field_inputs/text/EditText';
import EditBoolean from './shared/field_inputs/boolean/EditBoolean';
import EditSelectLabel from './shared/field_inputs/select_label/EditSelectLabel';
import EditItemList from './shared/field_inputs/item_list/EditItemList';
import { createGetSuggestionsFromApiUrl } from './shared/field_inputs/HelpMethods';

import { HandleAddOrganization } from './requests/OrganizationRequests';
import { CalculateSettings } from './shared/Functions';

const prependInTable = (organization, store, dispatch) => {
    store.rows.splice(0, 0, organization);
    store.requestObject.amount += 1;
    store.viewSettings = CalculateSettings(store.viewSettings, store.requestObject);
    dispatch({ type: 'UPDATE_DATA', payload: store.rows });
    dispatch({ type: 'UPDATE_VIEW_SETTINGS_AND_REQUEST_OBJECT', viewSettings: store.viewSettings, requestObject: store.requestObject });
};

const AddOrganization = () => {
    const { dispatch, store } = useContext(DataContext);
    const {
        store: { LabelOptions },
    } = useContext(SharedDataContext);

    const formComponents = [
        {
            propName: 'name',
            label: 'Namn',
            validate: (v) => (!v || !v.length ? 'Fyll i namn.' : ''),
            component: <EditText autoFocus />,
        },
        {
            propName: 'organizationType',
            label: 'Label',
            component: <EditSelectLabel options={LabelOptions} showLabelIcon />,
        },
        {
            propName: 'persons',
            label: 'Personer',
            component: (
                <EditItemList
                    iconName='people'
                    isClearable
                    isCreationPermitted
                    getSuggestions={null}
                />
            ),
        },
        {
            propName: 'frameworkAgreement',
            label: 'Ramavtal',
            component: <EditBoolean size='sm' />,
        },
        {
            propName: 'publicSector',
            label: 'Offentlig sektor',
            component: <EditBoolean size='sm' />,
        },
    ];

    const handleAdd = async (organization) => {
        const response = await HandleAddOrganization(organization);
        if (response.success) {
            prependInTable(response.data, store, dispatch);
        }
        return response;
    };

    return (
        <GenericFormModal
            label='+ Organisation'
            description='Lägg till ny Organisation'
            formComponents={formComponents}
            handleAdd={handleAdd}
        />
    );
};

export default AddOrganization;
